.root {
  display: flex;
  align-items: flex-start;
  gap: 11px;
  width: 100%;
  padding: 9px 12px;
  border-radius: var(--radius-md);
  border: 1px solid transparent;
  background: transparent;
  color: var(--color-text);
  text-align: left;
  cursor: pointer;
  transition: background var(--duration-fast) var(--ease-standard),
    border-color var(--duration-fast) var(--ease-standard),
    transform var(--duration-fast) var(--ease-standard);
}

.root:hover {
  background: var(--color-surface-sunken);
}

.root:active {
  transform: scale(0.99);
}

.icon {
  font-size: 19px;
  margin-top: 1px;
  color: var(--color-text-secondary);
  flex-shrink: 0;
  transition: color var(--duration-fast) var(--ease-standard);
}

.copy {
  display: flex;
  flex-direction: column;
  gap: 1px;
  min-width: 0;
}

.label {
  font-size: 13.5px;
  font-weight: 600;
  line-height: 1.3;
}

.description {
  font-size: 12px;
  color: var(--color-text-tertiary);
  line-height: 1.35;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.active {
  background: var(--color-brand-primary-soft);
  border-color: rgba(11, 37, 69, 0.14);
}

.active .icon {
  color: var(--color-brand-primary);
}

.active .label {
  color: var(--color-brand-primary);
}
